import React from 'react';
import { FormattedMessage } from 'react-intl';

const DepositsAccepted = () => (
    <FormattedMessage
        id="dc.dibs-buyer-deposit.DepositsAccepted"
        defaultMessage="Deposits Now Accepted"
    />
);

export default DepositsAccepted;
